module.exports = __webpack_public_path__ + "catalog/items/firesafety/designated-smoking-area/designated-smoking-area.svg";